export default "__VITE_ASSET__BQT2UaZN__"